import React from 'react';
import { motion } from 'framer-motion';
import { PROFILE_INFO } from '../data/profile';

const About: React.FC = () => {
  // Parse markdown-style bold from the about text
  const renderAbout = (text: string) => {
    const parts = text.trim().split(/(\*\*[^*]+\*\*)/g);
    return parts.map((part, i) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return (
          <strong key={i} className="font-semibold text-foreground">
            {part.slice(2, -2)}
          </strong>
        );
      }
      return <span key={i}>{part}</span>;
    });
  };

  const paragraphs = PROFILE_INFO.about.trim().split('\n\n');

  return (
    <section className="screen-line-after px-4 py-12">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <h2 className="text-lg font-semibold text-foreground mb-6">About</h2>
        <div className="space-y-4">
          {paragraphs.map((p, i) => (
            <p key={i} className="text-sm md:text-base leading-8 text-muted-foreground">
              {renderAbout(p)}
            </p>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default About;